import { curry, type PlatformEvent } from 'lib/util'
import validate from 'lib/sequence/model/validate'
import reset from 'lib/sequence/model/api/reset'
import find from 'lib/sequence/component/children/find'
import focusFirstError from 'app/_shared/events/field/focusFirstError'

/**
 * Validate Personal Step Event Handler
 *
 * @param module    the current module composition object
 * @param component the current action's main component
 * @param event     the event object that triggered this handler
 */
const validatePersonalStep = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Promise<boolean> => {
  const model = module[G.MODEL]
  const { person } = model[G.CHILDREN]
  const { contactChannels } = person[G.CHILDREN]
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { user, person: personForm } = find(actionComponent)

  await validate(model)(user)

  reset(person)
  await validate(person)(personForm)
  await validate(contactChannels)(personForm)

  focusFirstError(module, component, event)

  return !!(model[G.STATE][G.ERROR]
    || person[G.STATE][G.ERROR]
    || contactChannels[G.STATE][G.ERROR])
}

export default curry(validatePersonalStep)
